import React from "react";
import "../../styles/pages-styles/landing-layout-pages-styles/WorkWithUsPage.css";

const WorkWithUsPage = () => {
  return (
    <div className="WorkWithUsPage-container">
      <h1>Work with us</h1>
      <p>
        PassMedicine is constantly adding and updating our resource. We are
        therefore always interested in hearing from talented authors who have an
        interest in medical education.
      </p>
      <hr />
      <div className="WorkWithUsPage-para">
        <p>Why work with us? </p>
        <ul>
          <li>
            <span id="bd"> We will pay you! </span> Our rates are more generous
            than other publishers - we are obsessed with quality and relevance
            and are willing to pay for it.
          </li>
          <li>
            It looks great on your <span id="bd">CV/job application.</span>{" "}
            Writing questions/topics not only shows your teaching ability but
            also demonstrates communication skills. We will provide all authors
            with a{" "}
            <span id="bd">certificate they can upload to their portfulio.</span>
          </li>
          <li>
            You'll be helping those trainee doctors behind you by being part of
            <span id="bd"> quality, affordable, respected resource.</span>
          </li>
        </ul>
      </div>

      <div className="WorkWithUsPage-para">
        <p>What are the potential rules available? </p>
        <ul>
          <li>
            <span id="bd"> Question writing. </span> This is available to
            authors who've passed the exam they intend to write for.
          </li>
          <li>
            <span id="bd">Question editing.</span> Authors who've had questions
            previously published by us are eligible to join our editorial team.
          </li>
          <li>
            <span id="bd"> Textbook topics.</span>
            PassMedicine has an extensive textbook covering all aspects of
            medical science. We're always updating and improving this.
          </li>
        </ul>
      </div>

      <div className="WorkWithUsPage-para">
        <p>There are a small number of requirements that we ask of authors: </p>
        <ul>
          <li>
            You have
            <span id="bd"> passed the exam </span> that you are writing
            questions for or are a specialist trainee or above in the topic you
            are writing for
          </li>
          <li>
            You can create
            <span id="bd">original material</span> which is neither copied nor
            derived from existing publications/websites/other sources.
          </li>
          <li>
            You have
            <span id="bd"> excellent written English </span>
            skills.
          </li>
        </ul>
      </div>

      <p>
        If you are interested in any of these rules please contact us using{" "}
        <a href="#">this form</a> .
      </p>
      <p>PassMedicine editorial team</p>
    </div>
  );
};

export default WorkWithUsPage;
